<template>
  <v-row>
    <v-col cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />

      <v-card flat v-if="comp">
        <v-card-title class="theme">
          <v-icon class="white--text">info</v-icon>
          <span class="headline ml-2 white--text">Company information</span>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12 py-0">
                <span class="title theme-text py-0">General Information</span>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  label="Company Name*"
                  persistent-hint
                  :disabled="tempDisable"
                  hint="Name of the company"
                  v-model="comp.name"
                  clearable
                  class="mt-5"
                  :rules="[validationRules.required]"
                >
                  <template v-slot:append-outer>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon small class="grey--text pt-1" v-on="on"
                          >help</v-icon
                        >
                      </template>
                      Name of your company
                    </v-tooltip>
                  </template>
                </v-text-field>

                <v-text-field
                  label="Website URL"
                  persistent-hint
                  :disabled="tempDisable"
                  hint="Company home page URL"
                  v-model="comp.url"
                  clearable
                  class="mt-5"
                >
                  <template v-slot:append-outer>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon small class="grey--text pt-1" v-on="on"
                          >help</v-icon
                        >
                      </template>
                      Provide a link to your homepage, website or where you
                      could be found easily.
                    </v-tooltip>
                  </template>
                </v-text-field>
                <v-select
                  v-model="comp.type"
                  label="Company Type*"
                  hint="Business area for the company"
                  :items="types"
                  validate-on-blur
                  :disabled="tempDisable"
                  persistent-hint
                  type="text"
                  :rules="[validationRules.required]"
                  clearable
                  class="mt-5"
                >
                  <template v-slot:append-outer>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon small class="grey--text pt-1" v-on="on"
                          >help</v-icon
                        >
                      </template>
                      Business area/category for your company.
                    </v-tooltip>
                  </template>
                </v-select>

                <v-text-field
                  :disabled="tempDisable"
                  label="Organization Number*"
                  persistent-hint
                  :rules="[validationRules.required]"
                  hint="Company registration number in your country"
                  v-model="comp.org_nr"
                  class="mt-5"
                  clearable
                >
                  <template v-slot:append-outer>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon small class="grey--text pt-1" v-on="on"
                          >help</v-icon
                        >
                      </template>
                      Provide the valid Organization/EIN for your company
                    </v-tooltip>
                  </template>
                </v-text-field>

                <v-autocomplete
                  label="Location*"
                  :rules="[validationRules.required]"
                  persistent-hint
                  hint="Location (Country) of the Company"
                  v-model="comp.location"
                  :items="countries"
                  item-text="name"
                  item-value="name"
                  :disabled="tempDisable"
                  class="mt-5"
                  clearable
                >
                  <template v-slot:append-outer>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon small class="grey--text pt-1" v-on="on"
                          >help</v-icon
                        >
                      </template>
                      Location where the company was founded.
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              
              


              <v-col class=" mx-n3 mt-2" cols="12">
                <span class="title theme-text">Contact Information</span>
              </v-col>
              <v-row>
              <v-col cols="12" md="5">
                <v-autocomplete
                  label="Country code"
                  persistent-hint
                  hint="Required for ISD code"
                  :items="countries"
                  :disabled="tempDisable"
                  item-text="name"
                  :return-object="true"
                  v-model="comp.contact_isd"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="7">
                <v-text-field
                  label="Phone / Mobile number"
                  persistent-hint
                  hint="eg 90000000"
                  type="tel"
                  :disabled="tempDisable"
                  validate-on-blur
                  :rules="[workPhoneNumberRule]"
                  v-model="comp.contact_phone"
                  clearable
                />
              </v-col>
              </v-row>
              
                <v-text-field
                  label="Contact Email"
                  persistent-hint
                  :disabled="tempDisable"
                  :rules="[validationRules.email]"
                  v-model="comp.contact_email"
                  clearable
                  class="mt-2"
                >
                  <template v-slot:append-outer>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon small class="grey--text pt-1" v-on="on"
                          >help</v-icon
                        >
                      </template>
                      Contact email for the company.
                    </v-tooltip>
                  </template>
                </v-text-field>
                <v-text-field
                  label="Address Line 1"
                  persistent-hint
                  :disabled="tempDisable"
                  v-model="comp.address_line1"
                  clearable
                  class="mt-2"
                />
                <v-text-field
                  label="Address Line 2"
                  persistent-hint
                  :disabled="tempDisable"
                  v-model="comp.address_line2"
                  clearable
                  class="mt-2"
                />
                <v-text-field
                  :disabled="tempDisable"
                  label="City"
                  persistent-hint
                  v-model="comp.city"
                  clearable
                  class="mt-2"
                />
                <v-text-field
                  :disabled="tempDisable"
                  label="State"
                  persistent-hint
                  v-model="comp.state"
                  clearable
                  class="mt-2"
                />
                <v-text-field
                  label="PostCode"
                  :disabled="tempDisable"
                  persistent-hint
                  v-model="comp.post_code"
                  clearable
                  class="mt-2"
                />
                </v-col>
              <v-col cols="12" md="7">
                <v-file-input
                  v-model="fileInput"
                  show-size
                  label="Add/Change company logo"
                >
                  <template v-slot:append-outer>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon small class="grey--text pt-1" v-on="on"
                          >help</v-icon
                        >
                      </template>
                      Provide the url to your company logo.
                    </v-tooltip>
                  </template>
                </v-file-input>
                <v-btn
                  class="save rounded-sm white--text ml-0"
                  depressed
                  @click="saveImage"
                  >Save
                </v-btn>
              </v-col>
              <v-col cols="12" md="7" />
            </v-row>
            <v-btn
              depressed
              class="save white--text rounded-sm text-capitalize ml-0"
              @click="save"
              >save
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>
<script>
import libphonenumber from "google-libphonenumber";
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";

export default {
  name: Component.Protected.Company.General,
  data: () => ({
    comp: null,
    breadcrumbs: Breadcrumbs.Company.General,
    types: Constants.Company.Types,
    phoneValidator: null,
    tempDisable: true,
    fileInput: null,
  }),
  computed: {
    ...mapGetters(["userInfo", "countries", "company", "companyInfo"]),
    workPhoneNumberRule() {
      if (!this.comp.contact_isd && !this.comp.contact_phone) {
        return true;
      }
      if (this.comp.contact_isd && !this.comp.contact_phone) {
        return Constants.PhoneNumber.Messages.Error.Required;
      }
      if (!this.comp.contact_isd && this.comp.contact_phone) {
        return Constants.PhoneNumber.Messages.Error.SelectISD;
      }
      if (isNaN(this.comp.contact_phone)) {
        return Constants.PhoneNumber.Messages.Error.InvalidFormat;
      }
      if (this.comp.contact_phone && this.comp.contact_phone.length < 8) {
        return Constants.PhoneNumber.Messages.Error.InvalidFormat;
      }
      if (!this.comp.contact_phone || !this.comp.contact_isd.code) {
        return Constants.PhoneNumber.Messages.Error.InvalidCountryCode;
      }
      const num = this.phoneValidator.parseAndKeepRawInput(
        this.comp.contact_phone,
        this.comp.contact_isd.code
      );
      if (!num) {
        return Constants.PhoneNumber.Messages.Error.InvalidFormat;
      }
      if (this.phoneValidator.isValidNumber(num)) return true;
      return Constants.PhoneNumber.Messages.Error.InvalidCountryCode;
    },
  },
  methods: {
    saveImage() {
      if (this.fileInput) {
        let fileExt = this.fileInput.name.split(".");
        fileExt = fileExt[fileExt.length - 1];
        const fileName = `company/${this.userInfo.namespace}/logo/${this.companyInfo.companyId}.${fileExt}`;
        const data = {
          action: 'companyUpdateLogo',
          fileName: fileName,
          metadata: {
            customMetadata: {
              namespace: this.userInfo.namespace,
              uid: this.userInfo.uid,
              type: "image",
            },
          },
          payload: {
            logo_url: "",
            company_id: parseInt(this.companyInfo.companyId),
          },
          content: this.fileInput,
        };

        this.$store
          .dispatch(Actions.Firebase.UploadImage, data)
          .then(() => {
            this.$store.dispatch(Actions.Company);
            this.snackbar = true;
            this.snackbarMessage = "Company logo updated";
          })
          .catch((err) => {
            console.error("could not upload logo", err);
            this.snackbar = true;
            this.snackbarMessage = "You can only upload image with size < 3mb";
          })
          .finally(() => {
            this.fileInput = null;
          });
      } else {
        return false;
      }
    },
    save() {
      if (this.$refs.form.validate()) {
        this.tempDisable = true;
        let contactISD = this.comp.contact_isd
          ? this.comp.contact_isd.dial_code
          : "";
        let payload = { ...this.comp, contact_isd: contactISD };

        this.$store
          .dispatch(Actions.CompanyUpdate, payload)
          .then(() => {
            this.$router.push({ name: Component.Protected.Company.Home });
          })
          .catch((e) => {
            console.error(Constants.Company.Messages.Error.Edit, e);
            this.snackbarMessage = Constants.Company.Messages.Error.Edit;
            this.snackbar = true;
          })
          .finally(() => (this.tempDisable = false));
      }
    },
    getISDStuff(countryCode) {
      return this.countries.filter((e) => e.dial_code === countryCode)[0];
    },
    setup() {
      if (this.userInfo.role !== Constants.Roles.HR) {
        this.$router.go(-1);
        return false;
      }
      this.phoneValidator = libphonenumber.PhoneNumberUtil.getInstance();
      this.tempDisable = false;
      this.$store
        .dispatch(Actions.Company.Info)
        .then(
          () =>
            (this.comp = {
              ...this.company,
              contact_isd: this.getISDStuff(this.company.contact_isd),
            })
        )
        .catch((e) => {
          console.error(Constants.Company.Messages.Error.Get, e);
          this.snackbar = true;
          this.snackbarMessage = Constants.Company.Messages.Error.Get;
        });
    },
  },
  created() {
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>

<style scoped>
div.v-card {
  border-radius: 5px;
}
</style>